import { Common } from "./Common";

export class Payment extends Common {
    committee_id?: string | null;
    donation_id?: string | null;
    donor_id?: string | null;
    receiver_id?: string | null;

    amount: number;
    payment_date: Date;
    mode?: string | null; // could be 'cash' | 'upi' | 'bank_transfer' | 'kind' etc.
    transaction_ref_no?: string | null;
    remarks?: string | null;
    urls?: string[] | null;
    status: string;

    donor_meta: any;
}
